import CloseIcon from '@mui/icons-material/Close';
import {Box, Divider, IconButton, Stack} from '@mui/material';

import {theme} from '~constants/theme';

import {Breadcrumbs} from '~components/header/breadcrumbs/Breadcrumbs';
import {HelpButton} from '~components/header/HelpButton';
import {BackButton} from './BackButton';
import {UserMenu} from './UserMenu';

export interface MainTitleBarProps {
  /**
   * Display a horizontal full-width divider between the breadcrumbs/title and the page content.
   * @default false
   */
  withTitleDivider?: boolean;
  showBackButton?: boolean;
  /**
   * Show the "Start onboarding guide" item in the Help & Feedback menu.
   * @default true
   */
  showOnboardingGuide?: boolean;
  showUserMenu?: boolean;
  titleActions?: React.ReactNode;
  onClose?: () => void;
  /**
   * Render only the page title, without the parent breadcrumb links.
   * @default false
   */
  titleOnly?: boolean;
}

export function MainTitleBar({
  withTitleDivider = false,
  showBackButton = false,
  showOnboardingGuide = true,
  showUserMenu = false,
  titleActions,
  onClose,
  titleOnly = false,
}: MainTitleBarProps) {
  return (
    <>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'
        sx={{paddingTop: titleOnly ? 1 : 2, paddingBottom: titleOnly ? 1 : 2}}
      >
        <Stack direction='row' alignItems='center' justifyContent='space-between' gap={3}>
          {showBackButton && <BackButton />}
          <Breadcrumbs titleActions={titleActions} titleOnly={titleOnly} />
        </Stack>

        <Box
          className='mainTitleBar-actions'
          display='flex'
          alignItems='center'
          gap={theme.spacing(1)}
          sx={{position: 'relative', zIndex: theme.zIndex.appBar}}
        >
          <HelpButton showOnboardingGuide={showOnboardingGuide} />
          {showUserMenu && <UserMenu />}
          {onClose && (
            <IconButton
              data-testid='main-title-bar-close-button'
              size='small'
              onClick={onClose}
              sx={{color: 'inherit'}}
            >
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </Stack>
      {withTitleDivider && (
        <Divider
          sx={(theme) => ({width: `calc(100% + ${theme.spacing(2 * 3)})`, marginX: -3})}
          orientation={'horizontal'}
        />
      )}
    </>
  );
}
